import { createInitializerQueueList } from './initializer-manager';
import { EnvironmentProviders } from '@angular/core';
import { DataPreloaderService } from '../services/data-preloader.service';
import { UserService } from '../services/user/user.service';
import { PwaService } from '../services/pwa.service';
import { GoogleTagManagerService } from '../services/google-tag-manager.service';
import { GlobalEventsService } from '../services/global-events.service';
import { RedirectorService } from '../services/redirector.service';
import { ContentUpdaterService } from '../services/content-updater/content-updater.service';
import { AbTestService } from '../ab-test/ab-test.service';
import { BankingService } from '../services/banking.service';
import { GameCategoryAttrService } from '../services/games/game-category-attribute.service';
import { GameProvidersService } from '../services/games/game-providers.service';
import { InstallAppService } from '../services/install-app.service';
import { SeoService } from '../services/seo.service';
import { CookieAcceptService } from '../services/cookie-accept.service';
import { LastPlayedGamesService } from '../services/games/last-played-games.service';
import { PaymentRoutingService } from '../vendor/payment-v3/payment-routing.service';
import { SideNavService } from '../shared/layout/side-menu/side-nav.service';
import { UserBonusesService } from '../services/user/user-bonuses.service';
import { ServerSentEventsService } from '../services/server-sent-events.service';
import { OneSignalService } from '../services/one-signal.service';
import { AllowPushService } from '../services/allow-push.service';
import { ZendeskChatService } from '../services/zendesk/zendesk-chat.service';
import { TabChannelService } from '../services/tab-channel.service';
import { UserRestrictionsService } from '../services/user/user-restrictions.service';
import { UserBonusesTimerService } from '../services/user/user-bonuses-timer.service';
import { PlatformPaymentService } from '../vendor/payment-v3/platform-payment.service';
import { WheelFortuneService } from '../services/wheel-fortune.service';
import { ClarityService } from '../services/clarity.service';
import { QwGuaranteeService } from '../services/qw-guarantee.service';

export const provideInitializer = () => {
  return [
    ...parallelInitializer,
  ];
};

const parallelInitializer: EnvironmentProviders[] = createInitializerQueueList([
  {
    token: DataPreloaderService,
    initializerFn: (service: DataPreloaderService) => service.preloadCriticalData(),
  },
  {
    token: UserService,
    initializerFn: (service: UserService) => service.updateUserLang(),
  },
  {
    token: PwaService,
    initializerFn: (service: PwaService) => service.registerServiceWorker(),
  },
  {
    token: GoogleTagManagerService,
    initializerFn: (service: GoogleTagManagerService) => service.addGtmToDom(),
  },
  {
    token: OneSignalService,
    initializerFn: (service: OneSignalService) => service.handleId(),
  },
  {
    token: AllowPushService,
    initializerFn: (service: AllowPushService) => service.init(),
  },
  {
    token: ClarityService,
    initializerFn: (service: ClarityService) => service.initClarity(),
  },
  {
    token: ZendeskChatService,
    initializerFn: (service: ZendeskChatService) => service.initChat(),
  },
  {
    token: GlobalEventsService,
    initializerFn: (service: GlobalEventsService) => service.initGlobalEvent(),
  },
  {
    token: SeoService,
    initializerFn: (service: SeoService) => service.updateGlobalHeadLink(),
  },
  {
    token: InstallAppService,
    initializerFn: (service: InstallAppService) => service.checkIfShowInstallAppByCMS(),
  },
  {
    token: GameCategoryAttrService,
    initializerFn: (service: GameCategoryAttrService) => service.updateCategoryAttrListOnLangChange(),
  },
  {
    token: GameProvidersService,
    initializerFn: (service: GameProvidersService) => service.updateProviderListOnLangChange(),
  },
  {
    token: ContentUpdaterService,
    initializerFn: (service: ContentUpdaterService) => service.runContentChangeHandler(),
  },
  {
    token: BankingService,
    initializerFn: (service: BankingService) => service.fetchPayments(),
  },
  {
    token: RedirectorService,
    initializerFn: (service: RedirectorService) => service.detectNoCacheParameter(),
  },
  {
    token: UserService,
    initializerFn: (service: UserService) => service.checkAvailableRegistration(),
  },
  {
    token: AbTestService,
    initializerFn: (service: AbTestService) => service.syncUserAbTestGroup()
  },
  {
    token: CookieAcceptService,
    initializerFn: (service: CookieAcceptService) => service.acceptCookie()
  },
  {
    token: LastPlayedGamesService,
    initializerFn: (service: LastPlayedGamesService) => service.resolveLastPlayedGames(),
  },
  {
    token: PaymentRoutingService,
    initializerFn: (service: PaymentRoutingService) => service.resolvePaymentRoute()
  },
  {
    token: PaymentRoutingService,
    initializerFn: (service: PaymentRoutingService) => service.resolvePaymentSession()
  },
  {
    token: SideNavService,
    initializerFn: (service: SideNavService) => service.loadMenu()
  },
  {
    token: UserBonusesService,
    initializerFn: (service: UserBonusesService) => service.loadAllBonuses()
  },
  {
    token: ServerSentEventsService,
    initializerFn: (service: ServerSentEventsService) => service.initSseEvents(),
  },
  {
    token: TabChannelService,
    initializerFn: (service: TabChannelService) => service.init(),
  },
  {
    token: UserRestrictionsService,
    initializerFn: (service: UserRestrictionsService) => service.initPlayerRestrictions(),
  },
  {
    token: UserBonusesTimerService,
    initializerFn: (service: UserBonusesTimerService) => service.createTimer(),
  },
  {
    token: QwGuaranteeService,
    initializerFn: (service: QwGuaranteeService) => service.init(),
  },
  {
    token: PlatformPaymentService,
    initializerFn: (service: PlatformPaymentService) => service.checkCashoutFailSse(),
  },
  {
    token: WheelFortuneService,
    initializerFn: (service: WheelFortuneService) => service.resolveWheelRoute(),
  }
]);
